import { render } from "./2.GeneralPartners.vue?vue&type=template&id=d27a4706&scoped=true"
import script from "./2.GeneralPartners.vue?vue&type=script&lang=js"
export * from "./2.GeneralPartners.vue?vue&type=script&lang=js"

import "./2.GeneralPartners.vue?vue&type=style&index=0&id=d27a4706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27a4706"]])

export default __exports__